import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-universita-box',
  templateUrl: './universita-box.component.html',
  styleUrls: ['./universita-box.component.scss']
})
export class UniversitaBoxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
